import React from 'react';
import { IChatTaskFeatureConfig, ChatTaskFeatureConfigSchema } from '@scale/shared/types/config';
import { ZodFormBuilder } from './ZodFormBuilder';

interface Props {
  value: IChatTaskFeatureConfig;
  setValue: React.Dispatch<React.SetStateAction<IChatTaskFeatureConfig>>;
  fieldIds?: string[];
  omitCopyAndPasteConfigs?: boolean;
}

const ChatTaskFeatureConfig: React.FC<Props> = ({
  value,
  setValue,
  fieldIds,
  omitCopyAndPasteConfigs = true,
}) => {
  return (
    <div className="py-6">
      <ZodFormBuilder
        label="Chat Task Feature Configs"
        schema={
          omitCopyAndPasteConfigs
            ? ChatTaskFeatureConfigSchema.omit({
                // these are redundant with configs in Chat Task Configs
                disablePasting: true,
                disableCopying: true,
              })
            : ChatTaskFeatureConfigSchema
        }
        value={value}
        onChange={setValue}
        fieldIds={fieldIds}
      />
    </div>
  );
};

export default ChatTaskFeatureConfig;
